import styled from "styled-components";

export const PorductBreadcrumbWrapper = styled.div`
  position: fixed;
  background: var(--Grey-800, #fcfcfc);
  padding: 0 60px;
  width: 100%;
  z-index: 1;
`;
